import { createRouter, createWebHistory } from 'vue-router';
import PixelGrid from '../components/PixelGrid.vue';
import AboutPage from '../components/AboutPage.vue';
import HowToByPage from '../components/HowToBuyPage.vue';
import FaqPage from '@/components/FaqPage.vue';
import XbankPage from '@/components/XbankPage.vue';
import ProfilePage from '@/components/ProfilePage.vue';
import TermsPage from '@/components/TermsPage.vue';
import AdminLogin from '@/components/AdminLogin.vue';
import AdminOrders from '@/components/AdminOrders.vue';
import AdminOrder from '@/components/AdminOrder.vue';
import AdminGridReload from '@/components/AdminGridReload.vue';
import CenterSpotsPage from '@/components/CenterSpotsPage.vue';

const routes = [
  {
    path: '/',
    name: 'PixelGrid',
    component: PixelGrid,
  },
  {
    path: '/about',
    name: 'AboutPage',
    component: AboutPage,
  },
  {
    path: '/faq',
    name: 'FaqPage',
    component: FaqPage,
  },
  {
    path: '/how-to-buy',
    name: 'HowToByPage',
    component: HowToByPage,
  },
  {
    path: '/xbank',
    name: 'XbankPage',
    component: XbankPage,
  },
  {
    path: '/center-spots',
    name: 'CenterSpotsPage',
    component: CenterSpotsPage,
  },
  {
    path: '/profile',
    name: 'ProfilePage',
    component: ProfilePage,
  },
  {
    path: '/terms',
    name: 'TermsPage',
    component: TermsPage,
  },
  { 
    path: "/login", 
    name: 'AdminLogin',
    component: AdminLogin,
  },
  { 
    path: "/admin/orders", 
    name: 'AdminOrders',
    component: AdminOrders 
  },
  { 
    path: "/admin/orders/:id", 
    name: 'AdminOrder',
    component: AdminOrder 
  },
  { 
    path: "/admin/grid", 
    name: 'AdminGridReload',
    component: AdminGridReload 
  },
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_PUBLIC_PATH),
  routes,
});

export default router;
